import { ENV } from "../utils";

// Texto leído de los archivos de evidencia (ver server/services/evidenceReader.js)
export class EvidenceText {
  baseApi = ENV.BASE_API;

  async request(accessToken, path, options = {}) {
    const response = await fetch(`${this.baseApi}${path}`, {
      ...options,
      headers: { Authorization: `Bearer ${accessToken}`, ...(options.headers || {}) },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  // Lista (sin texto completo). Filtros opcionales: { module, refId, validity, company, site }
  // validity: "expired" | "expiring" | "outdated" | "valid"
  async getEvidenceTexts(accessToken, { module, refId, validity, company, site } = {}) {
    const params = new URLSearchParams();
    if (module) params.set("module", module);
    if (refId) params.set("refId", refId);
    if (validity) params.set("validity", validity);
    if (company) params.set("company", company);
    if (site) params.set("site", site);
    const qs = params.toString();
    return this.request(accessToken, `/evidence-texts${qs ? `?${qs}` : ""}`);
  }

  async getEvidenceText(accessToken, module, fileKey) {
    return this.request(accessToken, `/evidence-text/${encodeURIComponent(module)}/${encodeURIComponent(fileKey)}`);
  }

  // Archivo original (para previsualizarlo) como blob URL
  async getFile(accessToken, module, fileKey) {
    const response = await fetch(`${this.baseApi}/evidence-text/${encodeURIComponent(module)}/${encodeURIComponent(fileKey)}/file`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  async search(accessToken, q, module, validity, site, company) {
    const params = new URLSearchParams({ q });
    if (module) params.set("module", module);
    if (validity) params.set("validity", validity);
    if (company) params.set("company", company);
    if (site) params.set("site", site);
    return this.request(accessToken, `/evidence-texts/search?${params.toString()}`);
  }

  async reprocess(accessToken, module, fileKey) {
    return this.request(accessToken, `/evidence-text/${encodeURIComponent(module)}/${encodeURIComponent(fileKey)}/reprocess`, {
      method: "POST",
    });
  }
}
